import SliderComponent from '@components/shared/CustomSlider';
import NewSectionTitle from '@components/shared/NewSectionTitle';
import React from 'react';
import { FaPlay } from 'react-icons/fa';
import { HierarchyPrimary } from 'stories/Button.stories';

const recruitersTestimonialsList = [
  // {
  //   fullName: 'Sandhya.S',
  //   companyName: 'iOPEX Technologies',
  //   email: 'Sandhyashanmugham10@gmail.com',
  //   profileLink: 'https://www.linkedin.com/in/sandhya-s-866a4925b/',
  //   picture: '',
  //   postContent:
  //     "Great!! AlmaBetter Students are most matchable, what we are exactly looking for. and they very talented. It's very supportive to close the hiring TAT",
  // },

  {
    fullName: 'Navin Patel',
    companyName: 'Affine',
    email: 'navin.patel@affine.ai',
    profileLink: 'https://www.linkedin.com/in/navin-patel/',
    picture: '/assets/recruiters/Navin-Patel.webp',
    designation: 'Global TA Head at Affine',
    postContent:
      'It was our first batch of hire, from an outlook perse they look good. The team was quite resourceful and was quite responsive and support was always there.',
    videoLink: 'https://www.youtube.com/watch?v=PgiW_11ONMM',
  },

  {
    fullName: 'Lijosh V Joseph',
    companyName: 'Flutura Business Solutions Pvt Ltd',
    email: 'lijosh.joseph@flutura.com',
    profileLink: 'https://www.linkedin.com/in/lijosh-varkey-joseph-45990b48/',
    picture: '/assets/recruiters/Lijosh-V-Joseph.webp',
    designation: 'Director - Talent & Culture',
    postContent:
      'Our experience has been flawless. We just loved the way candidates have been mentored and nurtured at AlmaBetter. The quality has been great.',
    videoLink: 'https://www.youtube.com/watch?v=zitRQGaZiW8&t=7s',
  },

  {
    fullName: 'Megha Panchasara',
    companyName: 'Cartesian',
    email: 'mpanchasara@cartesianconsulting.com',
    profileLink: 'https://www.linkedin.com/in/megha-panchasara-88537373/',
    picture: '/assets/recruiters/Megha-Panchasara.webp',
    designation: 'Manager- HR',
    postContent:
      'The process was real quick and constant support made it easier and smooth. The candidates fulfilled the expectations, they are skilled and meets the criteria well.',
  },

  {
    fullName: 'Madhuri',
    companyName: 'LatentView Analytics',
    email: 'kannikanti.madhuri@latentview.com',
    profileLink: 'https://www.linkedin.com/in/kannikanti-madhuri/',
    picture: '/assets/recruiters/Madhuri.webp',
    designation: 'Manager - Talent Management and Campus',
    postContent: 'Yes,That was a great experience. 80% of the profiles got shortlisted and offered',
  },

  {
    fullName: 'Pratiksha Yadav',
    companyName: 'Digicides Marketing Services Private Limited',
    email: 'pratiksha.yaduwanshi@digicides.com',
    profileLink: 'https://www.linkedin.com/in/pratiksha-yadav-a33025139/',
    picture: '/assets/recruiters/Pratiksha-Yadav.webp',
    designation: 'Human Resources Manager',
    postContent:
      'For a fresher role, i feel the talent was good. They were curious self motivated and will add up to become meaningful resource in future. I was able to hire for a Data Analyst within 2 weeks. The process was quiet smooth. ',
  },

  {
    fullName: 'Ajay AS',
    companyName: 'Saasvaap Techies Pvt Ltd',
    email: 'ajay.as@saasvaap.com',
    profileLink: 'https://www.linkedin.com/in/ajay-a-s-0590325a/',
    picture: '/assets/recruiters/Ajay-AS.webp',
    designation: 'Manager - HRBP',
    postContent:
      'Awesome Experience, Happy to Associate with such a wonderful team. In terms of candidates, would be rating out of 5, i can give a 4',
  },

  {
    fullName: 'Madhusudan Dadhich',
    companyName: 'CloudThat',
    email: 'Madhusudan@cloudthat.com',
    profileLink: 'https://www.linkedin.com/in/madhusudandadhich/',
    picture: '/assets/recruiters/Madhusudan-Dadhich.webp',
    designation: 'Technical Recruiter',
    postContent:
      " Really liked the support from Almabetter throughout the interview process. The quality of the candidates was good and apt as per the JD shared. None of the candidates had any experience mentioned in their resume in which they haven't worked, we appreciate the discipline and honesty of the students aligned for the interview from Almabetter.",
  },

  // {
  //   fullName: 'Sarvani Ghantasala',
  //   companyName: 'YuppTV India Pvt Ltd',
  //   email: 'sarvanig@yupptv.com',
  //   profileLink: 'https://www.linkedin.com/in/sarvani-ghantasala-64a58b1b6/',
  //   picture: '',
  //   postContent:
  //     'It is good to work with Almabetter. Screening is good and is helpful in closing the positions in minimum time',
  // },

  {
    fullName: 'Vijay Giri ',
    companyName: 'Decision Point Analytics ',
    email: 'vjgiri1428@gmail.com',
    profileLink: 'https://www.linkedin.com/in/vijay-giri-6405a4201/',
    picture: '/assets/recruiters/Vijay-Giri.webp',
    designation: 'HR Executive',
    postContent:
      "It's preety amazing and very smooth process. The AlmaBetter team was very coordinative and pro active in complete hiring process. Most of the candidates were good.",
  },
];

const breakpoints = {
  320: {
    slidesPerView: 1,
    spaceBetween: 10,
  },

  1024: {
    slidesPerView: 2,
    spaceBetween: 32,
  },
};

function RecruiterTestimonials() {
  return (
    <div className="flex flex-col items-center gap-y-[72px] px-[16px] py-[60px] md:py-[120px] md:px-[40px]">
      <div className="flex flex-col items-center gap-y-[16px]">
        <NewSectionTitle
          text={'Here’s what our'}
          highlightedText={'Hiring partners say'}
          underlineStyle={'!underline-offset-[12px]'}
        />
      </div>

      <SliderComponent
        swiperOptions={{
          breakpoints,
          loop: true,
          autoplay: {
            delay: 3000,
            disableOnInteraction: false,
          },
        }}
        buttonStyle={{
          size: 24,
          buttonClass: 'bg-[#ffffffe6] border border-[#EAECF0] rounded-full col-span-6',
          leftButton: 'place-self-end',
          rightButton: 'place-self-start',
        }}
      >
        {recruitersTestimonialsList?.map((testimonial, index) => (
          <WallCard key={index} {...testimonial} />
        ))}
      </SliderComponent>
    </div>
  );
}

export default RecruiterTestimonials;

function WallCard({ fullName, companyName, email, postContent, picture, designation, videoLink }) {
  return (
    <div className="flex h-full cursor-pointer flex-col items-start gap-y-[24px] rounded-[20px] border border-gray-2 bg-[#FCFCFD] p-[32px]">
      <div className="grid w-full grid-cols-12">
        <img
          src={picture}
          className="col-span-3 h-[72px] w-[72px] rounded-full border border-gray-3 bg-white object-contain md:col-span-2"
        />

        <div className="col-span-6 flex flex-col items-start gap-y-[4px] md:col-span-7">
          <h3 className="font-satoshi-bold text-[18px] leading-6">{fullName}</h3>

          <p className="text-left font-satoshi-regular text-[14px] leading-5 text-[#98A2B3]">
            {designation} at {companyName}
          </p>
        </div>

        {videoLink && (
          <HierarchyPrimary
            linkCTA
            href={videoLink}
            target="_blank"
            label={'Watch Video'}
            customStyle={'col-span-3 flex-row-reverse self-start md:self-center'}
          >
            <FaPlay color="#880C25" size={20} className="hidden md:block" />
          </HierarchyPrimary>
        )}
      </div>

      <p className="text-left font-satoshi-medium text-[14px] leading-[20px] line-clamp-5 hover:line-clamp-none">
        {postContent}
      </p>
    </div>
  );
}
